import Cookies from "js-cookie";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTheme } from "../../../redux/action/action";

const ThemeTab = () => {
  const isDarkMode = useSelector((state) => state.isTheme === "dark");
  const dispatch = useDispatch();
  return (
    <section className="py-[20px] flex items-center justify-center gap-[30px]">
      <div
        onClick={() => {
          dispatch(setTheme("dark"));
          Cookies.set("color-mode", "dark");
        }}
        className="flex flex-col gap-[10px]"
      >
        <div
          className={`${
            isDarkMode && "border border-main-color"
          } w-[36px] h-[36px] bg-base-dark rounded-full`}
        ></div>
        <span
          className={`${
            isDarkMode && "text-base-light-dark dark:text-base-light-white"
          }`}
        >
          Dark
        </span>
      </div>
      <div
        onClick={() => {
          dispatch(setTheme("light"));
          Cookies.set("color-mode", "light");
        }}
        className="flex flex-col gap-[10px]"
      >
        <div
          className={`${
            !isDarkMode && "border border-main-color"
          } w-[36px] h-[36px] bg-base-white rounded-full`}
        ></div>
        <span
          className={`${
            !isDarkMode && "text-base-light-dark dark:text-base-light-white"
          }`}
        >
          Light
        </span>
      </div>
    </section>
  );
};

export default ThemeTab;
